import { expVal } from '@atlassian/jira-feature-experiments';

const platformAvpJdMergedDirectoryAfmRelayProvider = {
	get(): boolean {
		return expVal('platform_avp_jd_merged_directory_afm', 'isEnabled', false);
	},
};

export default platformAvpJdMergedDirectoryAfmRelayProvider;
